// base in 2.4.1
import Dropdown from './Dropdown';
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-dropdown/src/index.js
// module id = null
// module chunks = 